import { Button, Group, Stack, Title, Tooltip } from '@mantine/core'
import { OffersList } from '@/components/offers/offers-list/offers-list'
import { SeasonDropdown } from '@shared/components/season-dropdown/season-dropdown'
import { useMemo, useState } from 'react'
import { getSeasonYear } from '@shared/helpers/get-season-year/get-season-year'
import { useOfferCsvDownload } from '@/hooks/use-offer-csv-download'
import { IconDownload } from '@tabler/icons-react'

export function ViewOffers() {
  const [seasonStartDate, setSeasonStartDate] = useState<Date | undefined>(undefined)

  const seasonFilterValue: number | undefined = useMemo(
    () => seasonStartDate?.getFullYear(),
    [seasonStartDate]
  )

  const getCsvFilename = () => `offers-${getSeasonYear(seasonStartDate)}.csv`

  const { downloadCSV, isDownloading } = useOfferCsvDownload({
    stationRecordNumber: undefined,
    seasonFilterValue,
    filename: getCsvFilename(),
  })

  return (
    <Stack>
      <Group>
        <Title order={2} data-testid='offers-view-offers' mr='auto'>
          View Offers
        </Title>
        <SeasonDropdown
          seasonsBeforeCurrent={5}
          seasonsAfterCurrent={0}
          setSeasonStartDate={setSeasonStartDate}
          setSeasonEndDate={() => undefined} // Season end date is currently not used by this page
          showAllSeasons
        />
        <Tooltip label='Download raw data as CSV. Requires a season to be selected.'>
          <Button
            onClick={downloadCSV}
            leftSection={<IconDownload />}
            disabled={!seasonStartDate}
            loading={isDownloading}
          >
            Download
          </Button>
        </Tooltip>
      </Group>
      <OffersList seasonFilterValue={seasonFilterValue} />
    </Stack>
  )
}
